<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 15px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>入库维护</el-breadcrumb-item>
            <el-breadcrumb-item>入库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-col :span="24" style="text-align: right;">
            <el-button type="primary" @click="handleExport()">导出电子表格</el-button>
        </el-col>
        <el-card style="height: 100%;">
            <el-card style="margin-top: 30px;background-color: #eee;">
                <span style="background-color: #ddd;width: 100%;padding-bottom: 10px;"> 入库单编号：{{ rukudan_bianhao }} </span>
                <el-table ref="multipleTable" :data="kucunAddData" tooltip-effect="dark" style="width: 100%"
                    @selection-change="handleSelectionChange" :default-sort="{ prop: 'xuhao', order: 'descending' }">
                    <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index }}</template>
                    </el-table-column>
                    <el-table-column prop="pro_uid" label="商品序号" width="200"> </el-table-column>
                    <el-table-column prop="pro_name" label="商品名称" width="200"> </el-table-column>
                    <el-table-column label="商品类别" width="300">
                        <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                            scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                    </el-table-column>
                    <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </el-card>

        </el-card>
    </div>
</template>
<script>
import productTypeSelect from '../../tongyong/productType_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator';
export default {
    props: [
        'rukudanUid',
        'rukudanBianhao'
    ],
    data() {
        return {
            rukudan_bianhao: '',
            kucunAddData: [],
            kucunAddData_proUid: [],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_ruku_mingxi',
                rukudan_uid: this.rukudanUid
            },

            total: 0
            // 表单规则项
        };
    },
    created() {
        this.getrukuMingxiList()
        // this.rukudan_bianhao_get()
        this.rukudan_bianhao = this.rukudanBianhao
        console.log(this.rukudanBianhao)
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async getrukuMingxiList() {
            const { data: res } = await this.$http.post('api', this.queryInfo);
            console.log(JSON.parse(res.data)[0].dataList)
            this.kucunAddData = JSON.parse(res.data)[0].dataList
            // console.log(this.total)
        }
        //  分页第一项下拉触发
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
